var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},_vm._l((5),function(star){return _c('span',{key:star,staticClass:"cursor-pointer text-2xl",class:{
      'text-yellow-500': star <= _vm.currentRating || star <= _vm.hover,
      'text-gray-400': star > _vm.currentRating && star > _vm.hover
    },on:{"click":function($event){return _vm.setRating(star)},"mouseover":function($event){return _vm.hoverRating(star)},"mouseleave":_vm.resetHover}},[_vm._v(" ★ ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }